module.exports = __webpack_public_path__ + "img/bag.78ab5539.svg";